type Origin = { country?: { countryId: string } | null };

/**
 * Region membership is deliberately positive for both regions.
 * The engine returns a large number of UK rail stations with `country` unset.
 */
export function isOriginInRegion(origin: Origin, region: 'UK' | 'EU'): boolean {
  const countryId = origin.country?.countryId;

  if (!countryId) return false;

  return region === 'UK' ? countryId === 'UK' : countryId !== 'UK';
}
